var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplicantDetails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h32v32h-32z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.227,17.507C24.053,18.747 25.333,20.427 25.333,22.667V26.667H30.667V22.667C30.667,19.761 25.907,18.041 22.227,17.507Z",
    fill: "#E2897E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.001C14.946,16.001 17.334,13.613 17.334,10.668C17.334,7.722 14.946,5.334 12,5.334C9.055,5.334 6.667,7.722 6.667,10.668C6.667,13.613 9.055,16.001 12,16.001Z",
    fill: "#E2897E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,16.001C22.947,16.001 25.333,13.614 25.333,10.668C25.333,7.721 22.947,5.334 20,5.334C19.373,5.334 18.787,5.468 18.227,5.654C19.333,7.028 20,8.774 20,10.668C20,12.561 19.333,14.308 18.227,15.681C18.787,15.868 19.373,16.001 20,16.001Z",
    fill: "#E2897E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,17.334C8.44,17.334 1.333,19.121 1.333,22.668V26.668H22.666V22.668C22.666,19.121 15.56,17.334 12,17.334Z",
    fill: "#E2897E",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantDetails);
export default __webpack_public_path__ + "static/media/applicantDetails.ad49ccb163423ddf2c73d9d570f731a3.svg";
export { ForwardRef as ReactComponent };